enum ModTiersEnum {
	Grey = 1,
	Green = 2,
	Blue = 3,
	Purple = 4,
	Gold = 5,
}

export { ModTiersEnum };
